function encodeHTML (str) {
    return str.replace(/[\u00A0-\u9999<>&](?!#)/gim, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
}

function format (html) {
    const tab = '    ';
    let result = '';
    let indent = '';

    html.split(/>\s*</).forEach(function (element) {
        if (element.match(/^\/\w/)) {
            indent = indent.substring(tab.length);
        }

        result += indent + '<' + element + '>\r\n';

        if (element.match(/^<?\w[^>]*[^\/]$/)) {
            indent += tab;
        }
    });

    return result.substring(1, result.length - 3);
}

export default ({ error, template }) => `
    <info color="warning">
        Template contains the following errors:
        <pre>${error}</pre>
        <toggle opened="less">
            <toggle-content name="less">
                <toggle-trigger name="more">
                    <text-link color="error" bold="true">
                        Show template
                    </text-link>
                </toggle-trigger>
            </toggle-content>
            <toggle-content name="more">
                <pre style="white-space: pre-wrap;">${encodeHTML(format(template))}</pre>
                <toggle-trigger name="less">
                    <text-link color="error" bold="true">
                        Close template
                    </text-link>
                </toggle-trigger>
            </toggle-content>
        </toggle>
    </info>
`;
